<template>
  <div ref="view" class="goods-vip-forever">
    <!-- <div class="forever_top_box">
      <img
            class="animate__animated animate__infinite animate__pulse btn_check"
            @click="detailView('goods-order-list')"
            :src="dkUrl"
      />
    </div> -->
    <div v-for="(item, index) in defaultList" :key="index">
      <van-image fit="contain" lazy-load :src="item" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toFixedFloat } from '@/utils'
export default {
  name: 'goods-vip-forever2022',
  props: {
    goods: { type: Object, default: () => {} }
  },
  data() {
    return {
      // 查看抵扣
      dkUrl: 'https://img-cdn1.ylyk.com/image/1667187848525_m1667158618000_s55608.jpg',
      // 8号之后 无限卡落地页
      imgArr2: ['https://img-cdn1.ylyk.com/image/1716789141688_m1716789097946_s1327855.jpg']
    }
  },
  computed: {
    ...mapGetters('payment/order', ['disCountOrderList']),
    defaultList() {
      return this.imgArr2
    },
    discountList() {
      return this.disCountOrderList || []
    },
    discountTotal() {
      const total = this.disCountOrderList.discountTotal
      return toFixedFloat(total, 2)
    },
    salePrice() {
      let salePrice = this.goods.salePrice - this.discountTotal
      salePrice = salePrice < 0 ? 0 : toFixedFloat(salePrice, 2)
      return salePrice
    }
  },
  methods: {
    // 查看页面
    detailView(name, hasParam, index) {
      if (hasParam) {
        this.$router.push({ name: name, query: { index: index } })
      } else {
        if (!this.$parent.hasUser()) {
          return
        }
        this.$router.push({ name })
      }
    }
  }
}
</script>
<style scoped lang="less">
.goods-vip-forever {
  /deep/.van-image {
    margin-top: -1px; //部分机型 vant image组件有一道白线, 临时解决方案
    display: block;
  }
}
</style>
<style lang="scss" scoped>
.goods-vip-forever {
  &::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }
  // background-color: #00306a;
  position: relative;
  min-height: 100%;
  display: flex;
  // padding-bottom: 0.2rem;
  flex-direction: column;
  .forever_top_box {
    position: relative;
    .btn_check {
      display: block;
      width: 2.4rem;
      height: 0.55rem;
      position: absolute;
      top: 6.5rem;
      left: 35%;
      z-index: 10;
      transform: translateX(-50%);
    }
  }
}
.animate__animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animate__animated.animate__infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
</style>
